import {Component, ComponentType} from 'react';
import {useLocation} from 'react-router-dom';

import AppContext from './framework/AppContext';
import AppBar from './framework/component/frame/AppBar';

import Course from './researcher/training/quiz/Course';
import CourseList from './researcher/training/quiz/CourseList';
import Quiz from './researcher/training/quiz/Quiz';
import QuizList from './researcher/training/quiz/QuizList';
import QuizResult from './researcher/training/quiz/QuizResult';
import QuizStart from './researcher/training/quiz/QuizStart';
import Timeout from './researcher/training/quiz/Timeout';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js"


import './Home.css';
import DynamicSideBar from "./framework/component/menu/DynamicSideBar";
import AnnualReportLandingPage from "./researcher/annual-report/AnnualReportLandingPage";
import CommonAnnualReportForm from "./researcher/annual-report/form/CommonAnnualReportForm";
import ProjectList from "./application/ProjectList";
import ViewProject from "./application/ViewProject";
import {UserProfile} from "./framework/security/UserProfile";
import {Spinner} from "react-bootstrap";
import DataDeletion from "./application/data-deletion/DataDeletion";
import apiClient from "./framework/web/ApiClient";
import HomePage from "./core/HomePage";
import ApplicationTypeSelect from "./application/ApplicationTypeSelect";
import SysPrefsList from "./settings/SysPrefsList";

const withLocation = <P extends object>(WrappedComponent: ComponentType<P>) => {
    return (props: P) => {
        const location = useLocation();
        return <WrappedComponent {...props} location={location} />;
    };
};

interface HomeProps {
    id?: string;
    location?: {
        pathname: string;
        search: string;
        hash: string;
        state: any;
    }
}

interface HomeState {
  isLoading: boolean,
  error?: string,
  userRegistered?: boolean,
}

class Home extends Component<HomeProps> {

    static contextType = AppContext; // this line ensure the context variable below being populated
    context!: React.ContextType<typeof AppContext>;
    private urlHasIdentifier: boolean = false;
    state: HomeState;
    constructor(props: HomeProps) {
        super(props);
        this.state = {
          isLoading: true,
        };
    }

    #getRequestedComponent(): string {
        let queryParams = new URLSearchParams(window.location.search);
        let requestedComponent = queryParams.get('page');
        return requestedComponent || '';
    };

    componentDidMount() {
        this.fetchUserProfile();
    }

    fetchUserProfile = async () => {
        const headers = {
            "Content-Type": "application/json"
        };
        apiClient.get('/ams/api/v1/users/profiles', { withCredentials: true, headers })
            .then(response => {
                if (response.status != 204) {
                    if (response.data && response.data.data && this.context) {
                        this.setState({ isLoading: false });
                        this.context.userProfile = new UserProfile(response.data.data);
                    }
                }
            }).catch(error => {
                console.log('Error fetching user profile.', error);
                this.setState({ isLoading: false, error: 'There was a problem fetching your user profile.' });
            });
    };

    render() {
        let requestedComponent = this.#getRequestedComponent();
        const { location } = this.props;
        const pathArray = location?.pathname?.split('/');

        if ("" == requestedComponent || null == requestedComponent) {
            requestedComponent = pathArray?.[1] ?? '';
        }
        this.urlHasIdentifier = !!(pathArray && pathArray.length > 2);

        let contextValue = this.context;
        if (contextValue) {
            contextValue.currentPage = requestedComponent;
        } else {
            contextValue = {
                currentPage: requestedComponent,
                userProfile: new UserProfile()
            };
        }

        return (
                <div className="page">
                    <AppContext.Provider value={contextValue} >
                        <AppBar />
                        <div className="content-section" >
                            <DynamicSideBar />
            { this.state.isLoading && <Loading/> || this.state.error && <Error message={this.state.error}/> ||
                            <div className="content-area">
                                {requestedComponent === 'quiz-list' && <QuizList />}
                                {requestedComponent === 'quiz' && <Quiz shouldBlock={{ status: true }} />}
                                {requestedComponent === 'quiz-start' && <QuizStart />}
                                {requestedComponent === 'quiz-result' && <QuizResult />}
                                {requestedComponent === 'course-list' && <CourseList />}
                                {requestedComponent === 'course' && <Course />}
                                {requestedComponent === 'projects' && this.urlHasIdentifier && <ViewProject/>}
                                {requestedComponent === 'projects' && !this.urlHasIdentifier && <ProjectList/>}
                                {requestedComponent === 'timeout' && <Timeout />}
                                {requestedComponent === 'annual-report' && <AnnualReportLandingPage />}
                                {requestedComponent === 'annual-report-submit' && <CommonAnnualReportForm />}
                                {requestedComponent === 'data-deletion' && <DataDeletion />}
                                {requestedComponent === 'application-type' && <ApplicationTypeSelect />}
                                {requestedComponent === 'sys-prefs' && <SysPrefsList/>}
                                {!requestedComponent && <HomePage/>}
                            </div>
           }
                        </div>
                    </AppContext.Provider>
                </div>
        )
    };
}


function Loading() {
    return (
        <div className="content-area">
            <div className="loading-spinner">
                <div className="flex flex-row"><Spinner animation="border" role="status" variant="primary"/></div>
                <div className="flex flex-row"><h2 className="text-secondary mt-3">Loading, please wait...</h2></div>
            </div>
        </div>
    );
}

function Error({ message }: { message: string }) {
    return (
        <div className="content-area">
            <div className="loading-spinner">
                <div className="flex flex-row"><h2 className="text-danger mt-3">Error</h2></div>
                <div className="flex flex-row"><h5 className="text-secondary mt-3">{message}</h5></div>
            </div>
        </div>
    );
}

export default withLocation(Home);
